import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { ref as v } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { onMounted as u, watch as w, onBeforeUnmount as g } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
let o = 0, r = "", f = "", s = "", a = "";
const d = v("0px");
function R(c) {
  if (typeof document == "undefined")
    return;
  const e = document.documentElement;
  let l, t = !1;
  const n = () => {
    e.style.marginRight = r, e.style.overflow = f, e.style.overflowX = s, e.style.overflowY = a, d.value = "0px";
  };
  u(() => {
    l = w(c, (m) => {
      if (m) {
        if (!o) {
          const i = window.innerWidth - e.offsetWidth;
          i > 0 && (r = e.style.marginRight, e.style.marginRight = `${i}px`, d.value = `${i}px`), f = e.style.overflow, s = e.style.overflowX, a = e.style.overflowY, e.style.overflow = "hidden", e.style.overflowX = "hidden", e.style.overflowY = "hidden";
        }
        t = !0, o++;
      } else
        o--, o || n(), t = !1;
    }, {
      immediate: !0
    });
  }), g(() => {
    l == null || l(), t && (o--, o || n(), t = !1);
  });
}
export {
  d as lockHtmlScrollRightCompensationRef,
  R as useLockHtmlScroll
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/composable/use-lock-html-scroll.js
// module id = 1622
// module chunks = 67